<template>
  <Modal class-name = "card-modal" title = "Title" v-model = "showFormModal" :closable = "false">
    <div slot = "header">
      <h4>{{title}}</h4>
    </div>
    <Form ref = "creationModes" :model = "newCreationMode">
      <FormItem v-for = "(item, index) in newCreationMode.values"
                :key = "index" :label = "'Item ' + item.id" :prop = "'values.' + index + '.type'">
        <Divider></Divider>
        <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">Type:</i-col>
        <i-col :xs = "16" :sm = "16" :md = "16" :lg = "16">
          <Select v-model = "item.type" placeholder = "Select type">
            <Option value = "Manual" label = "Manual" :disabled = "handleDuplicate('Manual')" />
            <Option value = "Barcode" label = "Barcode" />
            <Option value = "QRCode" label = "QR Code" :disabled = "handleDuplicate('QRCode')" />
            <Option value = "NFC" label = "NFC" :disabled = "handleDuplicate('NFC')" />
          </Select>
        </i-col>
        <i-col :xs = "2" :sm = "2" :md = "2" :lg = "2">
          <Icon type="ios-remove-circle-outline" @click = "handleRemove(index)" style="font-size: 15pt;" title="Remove item" class="text-danger font-weight-bold" role="button" />
        </i-col>
        <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">Protocols:</i-col>
        <i-col :xs = "16" :sm = "16" :md = "16" :lg = "16">
          <Input v-show = "!displayBarcodeTypes(index)" type = "text" v-model = "item.protocols"
                 placeholder = "Input protocol"></Input>
          <Select v-show = "displayBarcodeTypes(index)" v-model = "item.protocols" placeholder = "Select type">
            <Option value = "Code39" label = "Code 39" :disabled = "handleBarCodeDuplicate('Code39')" />
            <Option value = "Code128" label = "Code 128" :disabled = "handleBarCodeDuplicate('Code128')" />
            <Option value = "EAN128" label = "EAN 128" :disabled = "handleBarCodeDuplicate('EAN128')" />
          </Select>
        </i-col>
        <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">Encoded:</i-col>
        <i-col :xs = "18" :sm = "18" :md = "18" :lg = "18">
          <RadioGroup v-model = "encode[index]" type = "button" @on-change = "translateBool(index, $event)">
            <Radio label = "True" />
            <Radio label = "False" />
          </RadioGroup>
        </i-col>
        <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">Option:</i-col>
        <i-col :xs = "16" :sm = "16" :md = "16" :lg = "16">
          <Input type = "text" v-model = "item.options" placeholder = "Input option"></Input>
        </i-col>
        <i-col :xs = "6" :sm = "6" :md = "6" :lg = "6">Key:</i-col>
        <i-col :xs = "16" :sm = "16" :md = "16" :lg = "16">
          <Input type = "text" v-model = "item.key" placeholder = "Input key"></Input>
        </i-col>
      </FormItem>

      <FormItem>
        <i-col :xs = "24" :sm = "24" :md = "24" :lg = "24">
          <Button long @click = "handleAdd" icon = "md-add">Add Creation Mode</Button>
        </i-col>
      </FormItem>
    </Form>
    <div slot = "footer" id = "dvFooter">
      <Button class="btn btn-outline-secondary btn-sm" @click = "handleCancel" style = "margin-left: 8px">
        Cancel
      </Button>
      <Button class="submit btn btn-success btn-sm" type = "success"
              @click = "handleSubmit">
        Save
      </Button>
    </div>
  </Modal>
</template>

<script>
  import {getCreationMode} from  '../../services/Events.service'

  export default {
    data() {
      return {
        newCreationMode: {},
        encode: [],
        showFormModal: false,
        title: '',
        action: '',
        index: 1,
        scanModes: ['manual'],
        oldCreationMode: {}
      }
    },
    props: ['creationModes'],
    methods: {
      openModeForm(title, action) {
        const self = this;
        self.encode = [];
        self.showFormModal = true;
        self.title = title;
        self.action = action;

        let data = JSON.parse(JSON.stringify(self.creationModes));
        delete data['_index'];
        delete data['_rowKey'];
        self.newCreationMode = data;

        let olddata = JSON.parse(JSON.stringify(self.creationModes));
        delete olddata['_index'];
        delete olddata['_rowKey'];
        self.oldCreationMode = olddata;

        self.index = self.creationModes.values.length;
        self.creationModes.values.map(function (a) {
          if (a.encoded)
            self.encode.push('True');
          else self.encode.push('False');
        })
      },
      handleRemove(index) {
        this.newCreationMode.values.splice(index, 1);
        this.encode.splice(index, 1);
        this.index--;
      },
      handleAdd() {
        const self = this;
        self.index++;
        self.encode.push('False');
        self.newCreationMode.values.push({
          id: self.index,
          type: null,
          protocols: null,
          encoded: 'False',
          options: null,
          key: null
        });
      },
      handleSubmit() {
        this.$emit('submitModes', this.newCreationMode);
        this.showFormModal = false;
      },
      handleCancel() {
        this.showFormModal = false;
      },
      handleDuplicate(str) {
        var dup = this.newCreationMode.values.filter(a => a.type === str);
        if (dup.length > 0) {
          return true;
        } else return false;
      },
      handleBarCodeDuplicate(str) {
        var dup = this.newCreationMode.values.filter(a => a.type === 'Barcode');
        if (dup.length > 0) {
          var result = this.newCreationMode.values.filter(a => a.protocols === str);
          if (result.length > 0) {
            return true;
          } else return false;
        } else
          return false;
      },
      displayBarcodeTypes(index) {
        if (this.newCreationMode.values[index].type === 'Barcode') {
          return true;
        } else return false;
      },
      translateBool(index, val) {
        if (val === 'True')
          this.newCreationMode.values[index].encoded = true;
        else this.newCreationMode.values[index].encoded = false;
      }
    }
  }
</script>

<style scoped>

  .vertical-center-modal {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ivu-modal {
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/k_globalAdministration/scanModeForm.vue